import React from 'react';
import PinwheelModal from '@pinwheel/react-modal';
import Loader from '../../../components/Loader';
import PinwheelError from './Pinwheel.error';

export default function PinwheelView({
  hasError,
  loading,
  onError,
  onEvent,
  onExit,
  onSuccess,
  token,
}) {
  if (loading) return (<Loader />);
  if (hasError) return (<PinwheelError />);
  return (
    <PinwheelModal
      linkToken={token}
      onError={onError}
      onEvent={onEvent}
      onExit={onExit}
      onSuccess={onSuccess}
      token={token}
      open
    />
  );
}
